import { render } from "./DiscoverArtistArchive.vue?vue&type=template&id=02bb756f&scoped=true"
import script from "./DiscoverArtistArchive.vue?vue&type=script&lang=js"
export * from "./DiscoverArtistArchive.vue?vue&type=script&lang=js"

import "./DiscoverArtistArchive.vue?vue&type=style&index=0&id=02bb756f&lang=scss&scoped=true"

import exportComponent from "/opt/project/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02bb756f"]])

export default __exports__